import React from 'react'
import { CalendarPlus } from 'lucide-react'

// ButtonWithIcon pinta `svg { fill }`; el estilo en línea lo anula para que el icono quede sólo con trazo.
const icon = ({ style, ...props }) => (
  <CalendarPlus size={18} style={{ fill: 'none', ...style }} {...props} />
)

export default icon
